import React from "react";
import { Link as NBLink } from "native-base";
import { WithHighlight } from "../hoc";

const linkFactory = function() {
    class Link extends React.Component {
        render() {
            const { href, label, active, onClick, children, className, _text = {}, forwardedRef, ...others } = this.props;
    
            const props = {
                href,
                _text,
                active,
                onClick,
                children,
            }

            return <NBLink { ...others } { ...props } ref={forwardedRef}>
                { label }
                { children }
            </NBLink>
        }
    }
    
    return React.forwardRef((props, ref) => {
        return <Link { ...props } forwardedRef={ref} />
    })
}
export const Link = WithHighlight(linkFactory())